import type { CalculatorPackage } from './calculatorPackages';
import { parsePackageNumber } from '@/pages/EU6Calculator/calculatorSettingsFromPackage';

const BUDGET_EPSILON = 0.01;

/** Compare budget sent on save vs budget returned/stored on the package document. */
export function packageBudgetPersistedMismatch(
  sentBudget: number,
  savedPackage: CalculatorPackage | undefined
): boolean {
  if (!savedPackage) return false;
  const returned = parsePackageNumber(savedPackage.totalBudget);
  if (returned == null) return true;
  return Math.abs(returned - sentBudget) > BUDGET_EPSILON;
}
